import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { isUserLoading, logOut as LogOutThunk, userRole } from "../../store/slices/user";
import { useAppDispatch, useAppSelector } from "../../store";

const useSidebar = () => {
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();
  const [currentKey, setCurrentKey] = useState("1");
  const role = useAppSelector(userRole);

  const isLoading = useAppSelector(isUserLoading);

  useEffect(() => {
    if (pathname) { // @TODO: format path for sub path "/path/subpath"
      if (currentKey !== pathname) {
        setCurrentKey(pathname);
      }
    }
  }, [pathname]);

  const logOut = () => dispatch(LogOutThunk());

  return {
    logOut,
    isLoading,
    currentKey,
    role
  };
};

export default useSidebar;
